const LoginFormLangKey = [
	'field_user_name_label',
	'field_user_name_placeholder',
	'field_password_label',
	'field_password_placeholder',
	'msg_login_success',
	'btn_login'
] as const

type ILoginFormLangKey = typeof LoginFormLangKey[number]

export type ILoginFormLang = {
	login_form: Record<ILoginFormLangKey, string>
}

const langEntries = LoginFormLangKey.map(
	(key: ILoginFormLangKey) => [key, `login_form.${key}`]
)

const langObj: Record<ILoginFormLangKey, string> = Object.fromEntries(langEntries)

export const LOGIN_FORM_LANG_KEY: ILoginFormLang = {
	login_form: langObj
}